import React, { useEffect } from "react";
import { ChartContainerProps } from "./Charts/ChartContainer";

interface DialogBoxProps {
  isOpen: boolean;
  className?: string,
  onClose: () => void;
  hideButtons?: boolean;
  children: React.ReactNode;
  freeDialogHeight?: boolean;
  height?: string | number;
  width?: string | number;
  otherActions?: ChartContainerProps["otherActions"];
}

const DialogBox: React.FC<DialogBoxProps> = ({
  isOpen, className, onClose, children, otherActions, hideButtons=false, freeDialogHeight=false, height, width,
}) => {
  // Close the dialog box when clicking outside of it
  const handleOutsideClick = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    // Disable scrolling when the dialog box is open
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto"; // Cleanup
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const DialogBoxButtons = hideButtons ? null : <>
    <button
      className="close-button"
      onClick={onClose} 
      style={{
        backgroundImage: `url('${__dirname}contract.png')`,
      }}
    />
    {
      otherActions && otherActions.length > 0 ? 
      <div className='other-actions'>
        {
        otherActions.map(({ image, text, style, action }, idx) => 
          <button
            key={idx}
            children={text}
            onClick={action}
            className={`action-button ${!text && image ? 'action-button--icon' : ''}`}
            style={{
              backgroundImage: (!text && image) ? `url('${__dirname}${image}')` : undefined,
              ...style,
            }}
          />)
        }
      </div> : <></>
    }
  </>;

  return (
    <div className="dialog-overlay" onClick={handleOutsideClick}>
      <div
        className={`dialog-box ${className}`}
        style={{
          ...(freeDialogHeight ? { 
            padding: 0,
            top: -170,
            height: "450px",
            maxHeight: "unset",
          } : {}),
          ...(height && { height: typeof height === 'number' ? `${height}px` : height }),
          ...(width && { width: typeof width === 'number' ? `${width}px` : width }),
        }}
      >
        {DialogBoxButtons}
        <div className="dialog-content" style={freeDialogHeight ? { 
          height: "85%",
        } : {}}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default DialogBox;
